<script setup>
const props = defineProps({
  name: {
    type: String,
    default: ''
  },
  color: {
    type: String,
    default: ''
  },
  width: {
    type: Number,
    default: 24
  },
  height: {
    type: Number,
    default: 24
  }
});
</script>

<template>
  <svg
    :style="{ width: `${props.width}px`, height: `${props.height}px`, color: `${props.color}` }"
    :viewBox="`0 0 ${props.width} ${props.height}`"
    class="svg-icon"
  >
    <use v-bind="{ 'xlink:href': `#${props.name}` }" />
  </svg>
</template>

<style lang="sass">
.svg-icon
    display: flex
    align-items: center
    justify-content: center
</style>
